<template>
<div id="login" class="">
  <b-container fluid>
    <b-row>
      <!-- <b-col md="4" class="text-white bg-dark">2 of 2</b-col> -->
      <b-col offset-lg="7" lg="3" md="6" offset-md="4" class="form-login mb-3">
        <b-card class="mb-1 animate__animated animate__fadeIn fix-card" footer-class="text-center">
          <b-card-body class="text-center align-items-center h2">
            <b-img :src="logoImg" class="w-100"></b-img>
            <!-- {{ logoName }} -->
          </b-card-body>

          <b-card-body>

            <div class="text-center" v-if="!dataReady">
              <b-spinner style="width: 3rem; height: 3rem;" label="Loading..." variant="info"></b-spinner>
            </div>
            <b-form @submit="loginUser" v-if="dataReady">
              <b-card-text>
                <label for="form_username" class="mb-1">Username:</label>
                <b-form-input id="form_username" required autocomplete="off" class="mb-2" v-model="form.userName" type="text" ></b-form-input>
                <label for="form_password" class="mb-1">Password:</label>
                <b-form-input id="form_password" required autocomplete="off" class="mb-2" v-model="form.password" type="password"></b-form-input>
              </b-card-text>
              <!-- <b-button variant="success" @click="loginUser" block pill>Log in</b-button> -->
              <b-button variant="success" type="submit" block pill>Log in</b-button>
            </b-form>

            <hr>
            <b-button variant="primary" pill @click="registerUser" block>Create an account</b-button>
          </b-card-body>
          <!-- <template #footer>
            <b-button href="#" variant="primary">Register</b-button>
          </template> -->
        </b-card>

      </b-col>
    </b-row>
  </b-container>
  <div class="authcenter-background" style="width: 1903px; height: 100vh; position: absolute; top: 0; left:0; overflow: hidden; z-index: -1;">
      <img class="authcenter-bg authcenter-bg-show" :src="bgNewImage" style="width: 1903px; height: 1189px; top: -250px;">
  </div>
</div>
</template>

<script>
import axios from 'axios' // api
export default {
  name: 'Login',
  beforeCreate () {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
    // document.body.className = 'login';
  },
  created () {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
  },
  async mounted () {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    this.$session.destroy()
    // localStorage.removeItem('memberData')
    // await this.getDataUser("tester")
  },
  data () {
    return {
      msg: 'Welcome Kathin',
      dataReady: true,
      bgNewImage: require('@/assets/BG_Licm.jpg'),
      form: {
        userName: '',
        password: ''
      }
    }
  },
  methods: {
    loginUser () {
      // let _this = this
      this.dataReady = false
      let urlAuthen = "https://licm-cargo.com/api/Authen/login"
      axios
        .post(
          // eslint-disable-next-line quotes
          urlAuthen,
          this.form,
          {
            headers: this.getHeaderAPI('Login', this.form.userName)
            // headers: this.headerAPI
          }
        )
        .then(async (response) => {
          // console.log('loginUser', response)
          let rs = response.data
          if (rs.status === true) {
            // this.$swal("เข้าระบบสำเร็จ")
            rs.timeout = new Date().getTime() + 900000
            // localStorage.setItem('memberData', JSON.stringify(rs))
            let jsonData = JSON.stringify(rs)

            this.$session.start()
            this.$session.set('mbd', jsonData)

            this.$router.push('/User/Dashboard')
          } else {
            console.log('loginUser Fail')
            this.$swal("ไม่สามารถเข้าระบบได้", rs.message, "error")
            this.dataReady = true
          }
          this.dataReady = true
        })
        .catch((error) => {
          // console.log(error)
          this.$swal("ERROR", "ไม่สามารถเข้าระบบได้ : "+ error, "error")
          // alert(error)
          // this.loginUser("http://licm-cargo.com/api/Authen/login")
          this.dataReady = true
        })
    },
    registerUser () {
      this.$router.push('/Register')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-login{
  margin-top: 60px;
}
label{
  font-weight: 600;
}
.fix-card{
  min-width: 365px;
  background: #c9e9d1AF;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue